// @core/api/endpoints/task/get_container_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ContainerConfigResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get container config
 * Returns task configuration for a container by config ID.
 */
export async function GetContainerConfig(
  config_id: string,
  options?: RequestOptions
): Promise<ContainerConfigResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/container-configs/:config_id`;
  requestPath = requestPath.replace(':config_id', encodeURIComponent(config_id));
  const requestOptions = options;
  return client.get<ContainerConfigResponse>(requestPath, { ...requestOptions });
}
